export const enTranslations: Record<string, string> = {
  'app.badge': 'Lumen Hospitality DPSK',
  'nav.overview': 'Overview',
  'nav.overviewDesc': 'Operational health, orchestration, and delivery channels',
  'nav.reception': 'Reception',
  'nav.receptionDesc': 'Operational lists, manual issuance, and bulk upload',
  'nav.administration': 'Administration',
  'nav.administrationDesc':
    'Dedicated lists and forms for tenants, vendors, locations, users, and infrastructure',
  'shell.consoleTitle': 'Operations Console',
  'shell.consoleDescription':
    'Multi-tenant dashboard for PMS flows, reception processes, network controller provisioning, and DPSK distribution.',
  'shell.livePosture': 'Live posture',
  'shell.loadingLocation': 'Loading location context',
  'shell.healthy': 'Healthy operating flow',
  'shell.attention': 'Attention on delivery channel',
  'shell.authSession': 'Authenticated session',
  'shell.guestOperator': 'Demo operator',
  'shell.noRole': 'No role',
  'shell.currentWorkspace': 'Current workspace',
  'shell.workspaceDescription': 'Active context for the selected page.',
  'shell.filters': 'Filters',
  'shell.tenant': 'Tenant',
  'shell.location': 'Hotel / Location',
  'shell.language': 'Language',
  'shell.theme': 'Theme',
  'shell.theme.system': 'System',
  'shell.theme.light': 'Light',
  'shell.loadingData': 'Updating data',
  'shell.searchTenant': 'Search tenant',
  'shell.searchLocation': 'Search hotel or location',
  'shell.noSearchResults': 'No matching results',
  'shell.closeFilters': 'Close filters',
  'dialog.cancel': 'Cancel',
  'dialog.deleteTitle': 'Confirm deletion',
  'dialog.extendTitle': 'Confirm extension',
  'dialog.revokeTitle': 'Confirm revoke',
  'shell.noPms': 'No PMS linked',
  'shell.noController': 'No controller linked',
  'shell.tvOn': 'TV enabled',
  'shell.tvPending': 'TV pending',
  'shell.emailOn': 'Email enabled',
  'shell.emailPending': 'Email pending',
  'shell.exitSession': 'Exit',
  'auth.mode.mock': 'Demo mode',
  'auth.mode.keycloak': 'Keycloak',
  'login.badge': 'Hospitality operations console',
  'login.title': 'Secure access to the hospitality platform.',
  'login.description':
    'Manage tenants, locations, users, vendors, and Wi-Fi credentials from a single console built for day-to-day operations.',
  'login.inputTitle': 'Tenants and locations',
  'login.inputBody': 'Control properties, units, vendors, and operational settings from a single place.',
  'login.logicTitle': 'Reception and credentials',
  'login.logicBody': 'Issue, renew, and monitor Wi-Fi codes for guests, staff, and events without extra steps.',
  'login.outputTitle': 'Operational visibility',
  'login.outputBody': 'Check service status, queues, and credential delivery at a glance.',
  'login.accessMode': 'Sign in',
  'login.demoWorkspace': 'Explore the platform',
  'login.keycloakWorkspace': 'Welcome back',
  'login.demoDescription':
    'Open the demo environment to explore the main workflows with sample data.',
  'login.keycloakDescription':
    'Sign in with your company account to continue.',
  'login.realm': 'Realm',
  'login.clientId': 'Client ID',
  'login.endpoint': 'Endpoint',
  'login.enterDemo': 'Open demo dashboard',
  'login.continueKeycloak': 'Sign in to the platform',
  'login.readyTitle': 'Centralized management',
  'login.readyBody':
    'Tenants, locations, units, users, and catalogs are available from a single operational console.',
  'login.supportTitle': 'Daily operations',
  'login.supportBody':
    'Work on reception flows, Wi-Fi credentials, and service settings with a simpler experience.',
  'login.demoNote': 'The demo environment uses sample data and is meant for exploration only.',
  'login.switchNote':
    'If you have trouble signing in, contact your service administrator.',
  'overview.context': 'Operational overview',
  'overview.title': 'Selected location status',
  'overview.subtitle':
    'Quick indicators about DPSK usage, VLAN mapping, and site operational load.',
  'overview.card.active.label': 'Active identities',
  'overview.card.active.caption': 'DPSKs currently valid on the selected location',
  'overview.card.scheduled.label': 'Scheduled arrivals',
  'overview.card.scheduled.caption': 'Credentials already created and waiting for check-in or event start',
  'overview.card.mapped.label': 'Mapped units',
  'overview.card.mapped.caption': '{rooms} rooms, {publicAreas} public areas, {eventHalls} event halls',
  'overview.card.daily.label': 'Daily trigger volume',
  'overview.card.daily.caption': 'Expected load across PMS, reception, and manual requests',
  'overview.locationHealth': 'Service posture',
  'overview.deliveryChannels': 'Delivery channels',
  'overview.connected': 'Connected',
  'overview.fallback': 'Fallback active',
  'overview.accounting': 'Accounting',
  'overview.accountingBody': 'RADIUS logs remain centralized for compliance and analytics.',
  'overview.operationalFlow': 'Operational flow',
  'overview.flowAligned': 'Aligned with the source document scenarios',
  'overview.channelMix': 'Channel mix',
  'overview.distributionSplit': 'Delivery split',
  'overview.channelShare': '{share}% of visible total',
  'overview.infrastructure': 'Units and VLANs',
  'overview.infrastructureDesc': 'Rooms, common areas, and event halls available on this location.',
  'overview.alerts': 'Attention board',
  'overview.alertsTitle': 'Current risks and anomalies',
  'overview.noAlerts': 'No open anomalies on the current location.',
  'overview.queue': 'Background queue',
  'overview.queueTitle': 'Bulk import status',
  'overview.queueProgress': '{processed}/{total} processed, target VLAN {vlan}',
  'overview.credentials': 'Recent credentials',
  'overview.credentialsTitle': 'Latest issued DPSKs',
  'overview.table.guest': 'Guest',
  'overview.table.space': 'Unit',
  'overview.table.type': 'Type',
  'overview.table.vlan': 'VLAN',
  'overview.table.ssid': 'SSID',
  'overview.table.panMode': 'PAN mode',
  'overview.table.source': 'Source',
  'overview.table.channels': 'Channels',
  'overview.table.validity': 'Validity',
  'overview.table.devices': 'Devices',
  'table.pagination.previous': 'Previous',
  'table.pagination.next': 'Next',
  'table.pagination.summary': '{from}-{to} of {total}',
  'overview.flow.trigger.title': 'PMS / Reception trigger',
  'overview.flow.trigger.body': 'Webhook, operator form, or CSV generates the access request.',
  'overview.flow.normalize.title': 'Identity normalization',
  'overview.flow.normalize.body':
    'The platform assigns hotel, unit, VLAN, and validity window.',
  'overview.flow.provision.title': 'Network controller provisioning',
  'overview.flow.provision.body':
    'The DPSK is associated with the mapped VLAN and lifecycle window.',
  'overview.flow.deliver.title': 'Channel delivery',
  'overview.flow.deliver.body': 'TV, email, dashboard, or print receives QR code and password.',
  'overview.flow.monitor.title': 'Monitoring and accounting',
  'overview.flow.monitor.body':
    'Usage, queues, channel adoption, and accounting remain visible to operations.',
  'reception.pageKicker': 'Reception operations',
  'reception.pageTitle': 'DPSK issuance and lifecycle management',
  'reception.pageDescription':
    'The reception area is organized into dedicated pages: code list, manual issuance, and bulk upload.',
  'reception.tab.issue': 'Issue',
  'reception.tab.codes': 'Code management',
  'reception.tab.bulk': 'Bulk upload',
  'reception.tab.events': 'Events',
  'reception.summary.active': 'Active',
  'reception.summary.scheduled': 'Scheduled',
  'reception.summary.archived': 'Archived',
  'reception.summary.queue': 'Bulk jobs',
  'reception.issue.kicker': 'Manual issuance',
  'reception.issue.title': 'Create a DPSK for guests and exceptional cases',
  'reception.issue.description':
    'For walk-ins, suppliers, bar access, or PMS fallback. Generate QR code and clear-text password.',
  'reception.fields.firstName': 'First name',
  'reception.fields.lastName': 'Last name',
  'reception.fields.email': 'Email',
  'reception.fields.space': 'Unit',
  'reception.fields.selectSpace': 'Select a unit',
  'reception.fields.reference': 'Booking / voucher reference',
  'reception.fields.validFrom': 'Valid from',
  'reception.fields.validUntil': 'Valid until',
  'reception.fields.devicesAllowed': 'Allowed devices',
  'reception.fields.category': 'Guest category',
  'reception.fields.deliveryChannels': 'Delivery channels',
  'reception.fields.serviceMode': 'Service mode',
  'reception.fields.notes': 'Operator notes',
  'reception.category.guest': 'Guest',
  'reception.category.visitor': 'Visitor',
  'reception.category.iot': 'IoT',
  'reception.category.staff': 'Staff',
  'reception.category.journalist': 'Journalist',
  'reception.category.relator': 'Speaker',
  'reception.categoryDescription.staff': 'The code is created on the preset VLAN.',
  'reception.categoryDescription.iot': 'The code is created on the preset VLAN.',
  'reception.categoryDescription.visitor': 'The code is created on the preset VLAN.',
  'reception.categoryDescription.guest': 'Select the room to associate its VLAN.',
  'reception.preview.kicker': 'Voucher preview',
  'reception.preview.title': 'Operator card',
  'reception.preview.empty': 'Select a unit to preview the QR code.',
  'reception.preview.guest': 'Guest',
  'reception.preview.ssidVlan': 'SSID / VLAN',
  'reception.preview.panMode': 'PAN mode',
  'reception.preview.expires': 'Expiry',
  'reception.lastCreated': 'Last created code',
  'reception.lastCreatedEmpty':
    'Generate a manual DPSK to display the latest voucher summary here.',
  'reception.generate': 'Generate DPSK',
  'reception.creating': 'Creating...',
  'reception.codes.kicker': 'Code management',
  'reception.codes.title': 'Filter, extend, or revoke vouchers',
  'reception.filter.all': 'All',
  'reception.filter.pms': 'PMS',
  'reception.filter.reception': 'Reception',
  'reception.filter.bulk': 'Bulk',
  'reception.searchPlaceholder': 'Search guest or reference',
  'reception.activeList': 'Active / scheduled',
  'reception.archivedList': 'Archived / invalid',
  'reception.actions.extend': '+24h',
  'reception.actions.revoke': 'Revoke',
  'reception.actions.new': 'New DPSK',
  'reception.actions.backToCodes': 'Back to codes',
  'reception.actions.showQr': 'Show QR',
  'reception.actions.printQr': 'Print QR',
  'reception.confirm.extend': 'Extend voucher {name} by 24 hours?',
  'reception.confirm.revoke': 'Revoke voucher {name}?',
  'reception.activeEmpty': 'No active or scheduled codes match the current filters.',
  'reception.archivedEmpty': 'No archived or revoked codes match the current filters.',
  'reception.bulk.kicker': 'Bulk onboarding',
  'reception.bulk.title': 'CSV import for groups and events',
  'reception.bulk.loadFile': 'Load file',
  'reception.bulk.mode': 'Bulk mode',
  'reception.bulk.modeShared': 'Shared group VLAN',
  'reception.bulk.modeIsolated': 'Per-unit VLAN / isolation',
  'reception.bulk.defaultSpace': 'Default unit',
  'reception.bulk.requestedBy': 'Requested by',
  'reception.bulk.csvBody': 'CSV body',
  'reception.bulk.queue': 'Queue import',
  'reception.bulk.queueing': 'Queueing...',
  'reception.bulk.templateHint':
    'Expected columns: firstName, lastName, email, spaceId, validFrom, validUntil, devicesAllowed, bookingReference',
  'reception.bulk.jobs': 'Queue status',
  'reception.bulk.jobsTitle': 'Recent activity',
  'reception.emptyLocation': 'Select or create a location with available units.',
  'reception.message.created': 'Created {id} for {name}.',
  'reception.message.bulkQueued': 'Job {id} queued with {imported} identities ({status}).',
  'reception.message.extended': 'Extended validity for {id} by 24 hours.',
  'reception.message.revoked': 'Revoked code {id}.',
  'reception.message.emailed': 'Code {id} sent by email.',
  'reception.actions.sendEmail': 'Send by email',
  'events.kicker': 'Event Wi-Fi',
  'events.title': 'Create and manage event access',
  'events.name': 'Event name',
  'events.hall': 'Event hall',
  'events.duration': 'Duration',
  'events.code': 'Event code',
  'events.isolation': 'Client isolation',
  'events.network.loading': 'Loading networks...',
  'events.network.empty': 'No networks available',
  'events.network.loadError': 'Unable to load networks',
  'events.isolated': 'Isolated',
  'events.shared': 'Shared access',
  'events.policy': 'Policy',
  'events.contactName': 'Contact name',
  'events.create': 'New event',
  'events.edit': 'Edit event',
  'events.sendEmail': 'Send code by email',
  'events.disable': 'Disable event',
  'events.empty': 'No events configured for this location.',
  'events.message.saved': 'Event {name} saved.',
  'events.message.emailSent': 'Event code sent to {email}.',
  'events.message.disabled': 'Event {name} disabled.',
  'events.codes.kicker': 'Guest and visitor management',
  'events.codes.manage': 'Manage event codes',
  'events.codes.type': 'Code type',
  'events.codes.mode': 'Creation mode',
  'events.codes.personal': 'Personal',
  'events.codes.manual': 'Manual',
  'events.codes.bulk': 'Bulk import',
  'events.codes.personalManual': 'Personal · Manual',
  'events.codes.personalBulk': 'Personal · Bulk import',
  'events.codes.group': 'Group',
  'events.codes.manualTitle': 'Create a personal code',
  'events.codes.bulkTitle': 'Import personal codes from CSV',
  'events.codes.groupTitle': 'Create a group code',
  'events.codes.groupName': 'Group name',
  'events.codes.sendEmail': 'Send the code by email',
  'events.codes.service': 'Service',
  'events.codes.serviceHint': 'Use the service VLAN configured for the event hall.',
  'events.codes.serviceUnavailable': 'The selected hall has no service VLAN configured.',
  'events.codes.bulkHint': 'Required columns: firstName, lastName, email, category, devicesAllowed. Duration and hall are inherited from the event; processing is queued to respect vendor rate limits.',
  'events.codes.createPersonal': 'Create personal code',
  'events.codes.createGroup': 'Create group code',
  'events.codes.queueBulk': 'Queue CSV import',
  'events.codes.personalCreated': 'Personal code created: {code}',
  'events.codes.groupCreated': 'Group code created: {code}',
  'events.codes.bulkQueued': 'Import {id} queued: {imported} codes processed.',
  'admin.pageKicker': 'Administrative management',
  'admin.pageTitle': 'Tenants, controller/PMS vendors, locations, and users',
  'admin.pageDescription':
    'The administrative area uses dedicated pages for tenants, controller and PMS vendor catalogs, locations, users, and infrastructure.',
  'admin.vendorHintTitle': 'Vendor catalogs',
  'admin.vendorHintBody':
    'Before creating or updating a location you can register controller and PMS vendor catalogs, so dropdowns and configuration fields are ready inside the location forms.',
  'admin.card.tenants.label': 'Tenants',
  'admin.card.tenants.caption': 'Multi-tenant portfolio managed from the panel',
  'admin.card.locations.label': 'Locations',
  'admin.card.locations.caption': 'Hotels, resorts, and venues available in the prototype',
  'admin.card.users.label': 'Users',
  'admin.card.users.caption': 'Operational roles and assignments managed through mock state',
  'admin.card.spaces.label': 'Units / VLANs',
  'admin.card.spaces.caption': 'Current unit inventory for the selected location',
  'admin.tab.tenants': 'Tenants',
  'admin.tab.locations': 'Locations',
  'admin.tab.users': 'Users',
  'admin.tab.controllerVendors': 'Controller vendors',
  'admin.tab.pmsVendors': 'PMS vendors',
  'admin.tab.infrastructure': 'Infrastructure',
  'admin.tenants.kicker': 'Tenant management',
  'admin.tenants.title': 'Create and update tenants',
  'admin.locations.kicker': 'Location management',
  'admin.locations.title': 'Manage hotels, resorts, and venues',
  'admin.locations.filterHint':
    'Select a tenant to display only its related locations, without using the global operational filters.',
  'admin.users.kicker': 'User management',
  'admin.users.title': 'Roles, tenant scopes, and location scopes',
  'admin.controllerVendors.kicker': 'Controller catalog',
  'admin.controllerVendors.title': 'Register and manage controller vendors',
  'admin.controllerVendors.empty': 'No controller vendors are registered yet.',
  'admin.controllerVendors.emptyHint':
    'Add the first controller vendor to make it available while onboarding locations.',
  'admin.pmsVendors.kicker': 'PMS catalog',
  'admin.pmsVendors.title': 'Register and manage PMS vendors',
  'admin.pmsVendors.empty': 'No PMS vendors are registered yet.',
  'admin.pmsVendors.emptyHint':
    'Add the first PMS vendor to make it available while onboarding locations.',
  'admin.infrastructure.kicker': 'Inventory and integrations',
  'admin.infrastructure.title': 'Units, VLANs, and connector readiness',
  'admin.form.new': 'New',
  'admin.form.reset': 'Reset',
  'admin.form.create': 'Create',
  'admin.form.update': 'Update',
  'admin.form.name': 'Name',
  'admin.form.brand': 'Brand / description',
  'admin.form.sla': 'SLA',
  'admin.form.coverage': 'DPSK coverage %',
  'admin.form.city': 'City',
  'admin.form.category': 'Category',
  'admin.form.pms': 'PMS',
  'admin.form.pmsVendor': 'PMS vendor',
  'admin.form.pds': 'PDS config',
  'admin.form.controller': 'Controller',
  'admin.form.controllerVendor': 'Controller vendor',
  'admin.form.tv': 'TV integration',
  'admin.form.email': 'Email integration',
  'admin.form.integrations': 'Integrations',
  'admin.form.state': 'State',
  'admin.form.dailyCheckIns': 'Daily check-ins',
  'admin.form.activeGuests': 'Active guests',
  'admin.form.bulkQueue': 'Bulk queue',
  'admin.form.note': 'Operational note',
  'admin.form.timezone': 'Timezone',
  'admin.form.linkedTenant': 'Linked tenant',
  'admin.form.role': 'Role',
  'admin.form.status': 'User status',
  'admin.form.tenantScope': 'Tenant scope',
  'admin.form.locationScope': 'Location scope',
  'admin.form.fieldSchema': 'Field schema',
  'admin.form.fieldName': 'Field name',
  'admin.form.fieldType': 'Field type',
  'admin.form.fieldsHelp': 'Define at least one extra field for the vendor.',
  'admin.form.selectVendor': 'Select vendor',
  'admin.form.selectVendorFirst': 'Select a vendor first to configure the required fields.',
  'admin.form.pmsConfiguration': 'PMS configuration',
  'admin.form.controllerConfiguration': 'Controller configuration',
  'admin.form.vendorConfigurationHint':
    'Fill in all fields required by the selected vendor catalog entry.',
  'admin.form.noPmsVendorsAvailable':
    'No PMS vendor is available yet. Register the PMS catalog first.',
  'admin.form.noControllerVendorsAvailable':
    'No controller vendor is available yet. Register the controller catalog first.',
  'admin.form.addField': 'Add field',
  'admin.form.removeField': 'Remove field',
  'admin.form.createControllerVendor': 'Create controller vendor',
  'admin.form.createPmsVendor': 'Create PMS vendor',
  'admin.form.updateControllerVendor': 'Update controller vendor',
  'admin.form.updatePmsVendor': 'Update PMS vendor',
  'admin.form.controllerVendorNotFound': 'Controller vendor not found.',
  'admin.form.pmsVendorNotFound': 'PMS vendor not found.',
  'admin.form.vendorFieldType.string': 'String',
  'admin.form.vendorFieldType.number': 'Number',
  'admin.form.vendorFieldType.boolean': 'Boolean',
  'admin.form.vendorFieldType.password': 'Password',
  'admin.form.unitType': 'Unit type',
  'admin.form.assignment': 'Assignment',
  'admin.form.unitStatus': 'Unit status',
  'admin.list.portfolio': 'Portfolio',
  'admin.list.properties': 'Properties',
  'admin.list.coverage': 'Coverage',
  'admin.list.alerts': 'Alerts',
  'admin.list.noneTenants': 'No tenants are registered yet.',
  'admin.list.noneLocations': 'No locations available for the selected tenant.',
  'admin.tenants.emptyHint':
    'Create the first tenant to start the platform multi-tenant onboarding.',
  'admin.actions.edit': 'Edit',
  'admin.actions.toggleStatus': 'Toggle status',
  'admin.actions.newTenant': 'New tenant',
  'admin.actions.newLocation': 'New location',
  'admin.actions.newUser': 'New user',
  'admin.actions.newControllerVendor': 'New controller vendor',
  'admin.actions.newPmsVendor': 'New PMS vendor',
  'admin.actions.newRoomAssignment': 'New unit',
  'admin.actions.assignRoom': 'Edit unit',
  'admin.actions.manageInfrastructure': 'Infrastructure',
  'admin.actions.backToLocation': 'Back to location',
  'admin.actions.backToList': 'Back to list',
  'admin.actions.delete': 'Delete',
  'admin.infrastructure.inventory': 'Unit inventory',
  'admin.infrastructure.roomAssignments': 'Single-room assignments',
  'admin.infrastructure.roomAssignmentsDesc':
    'Each room is mapped individually with SSID, VLAN, and PAN mode. Use this area to create or correct the assignment for a single room.',
  'admin.infrastructure.locationScopeDesc':
    'This page belongs to the selected location. Infrastructure assignment is managed directly inside the location.',
  'admin.infrastructure.sharedSpaces': 'Shared units and event halls',
  'admin.infrastructure.noRooms': 'No room is configured for the selected location.',
  'admin.infrastructure.noSharedSpaces': 'No shared unit is configured.',
  'admin.infrastructure.roomPreview': 'Assignment preview',
  'admin.infrastructure.readiness': 'Integration readiness',
  'admin.integrations.queuePlaceholder': 'Redis / RabbitMQ to be defined in backend',
  'admin.integrations.pdsPlaceholder': 'PDS configuration to be defined',
  'admin.form.createTenant': 'Create tenant',
  'admin.form.updateTenant': 'Update tenant',
  'admin.form.tenantNotFound': 'Tenant not found.',
  'admin.form.createLocation': 'Create location',
  'admin.form.updateLocation': 'Update location',
  'admin.form.locationNotFound': 'Location not found.',
  'admin.form.createUser': 'Create user',
  'admin.form.updateUser': 'Update user',
  'admin.form.userNotFound': 'User not found.',
  'admin.form.roomName': 'Room',
  'admin.form.ssid': 'SSID',
  'admin.form.vlanId': 'VLAN',
  'admin.form.serviceVlanId': 'Service VLAN',
  'admin.form.networkId': 'Network ID',
  'admin.form.capacity': 'Capacity',
  'admin.form.createRoomAssignment': 'Create unit',
  'admin.form.updateRoomAssignment': 'Update unit',
  'admin.form.roomAssignmentDescription':
    'Define the Wi-Fi mapping for a single unit. The configuration becomes available immediately in the location inventory and reception flows.',
  'admin.form.roomNotFound': 'Unit not found.',
  'admin.form.locationRequiredForRoom':
    'Select a location before registering a unit.',
  'admin.message.tenantSaved': 'Tenant {name} saved.',
  'admin.message.tenantDeleted': 'Tenant {name} deleted.',
  'admin.message.locationSaved': 'Location {name} saved.',
  'admin.message.locationDeleted': 'Location {name} deleted.',
  'admin.message.userSaved': 'User {name} saved.',
  'admin.message.userDeleted': 'User {name} deleted.',
  'admin.message.controllerVendorSaved': 'Controller vendor {name} created.',
  'admin.message.pmsVendorSaved': 'PMS vendor {name} created.',
  'admin.message.controllerVendorUpdated': 'Controller vendor {name} updated.',
  'admin.message.pmsVendorUpdated': 'PMS vendor {name} updated.',
  'admin.message.controllerVendorDeleted': 'Controller vendor {name} deleted.',
  'admin.message.pmsVendorDeleted': 'PMS vendor {name} deleted.',
  'admin.message.roomAssignmentSaved': 'Infrastructure configuration saved for {name}.',
  'admin.message.roomDeleted': 'Room {name} deleted.',
  'admin.confirm.deleteTenant': 'Delete tenant {name} and all linked locations?',
  'admin.confirm.deleteLocation': 'Delete location {name} and its infrastructure?',
  'admin.confirm.deleteUser': 'Delete user {name}?',
  'admin.confirm.deleteRoom': 'Delete room {name}?',
  'admin.confirm.deleteControllerVendor': 'Delete controller vendor {name}?',
  'admin.confirm.deletePmsVendor': 'Delete PMS vendor {name}?',
  'validation.required': 'This field is required.',
  'validation.email': 'Enter a valid email address.',
  'validation.minValue': 'Enter a valid value.',
  'validation.fixErrors': 'Fix the highlighted fields before saving.',
  'validation.dateOrder': 'End date must be after the start date.',
  'validation.selectOne': 'Select at least one item.',
  'toast.dismiss': 'Dismiss notification',
  'toast.error.network': 'Unable to reach the backend service.',
  'toast.error.badRequest': 'The request is not valid.',
  'toast.error.unauthorized': 'Unauthorized session. Please sign in again.',
  'toast.error.forbidden': 'You do not have permission to complete this operation.',
  'toast.error.notFound': 'The requested resource was not found.',
  'toast.error.conflict': 'The operation cannot be completed because of a state conflict.',
  'toast.error.validation': 'The submitted data is not valid.',
  'toast.error.server': 'The server returned an internal error.',
  'toast.error.unavailable': 'The service is temporarily unavailable.',
  'toast.error.genericStatus': 'HTTP {status}: request failed.',
  'toast.error.unexpected': 'An unexpected HTTP error occurred.',
  'channel.tv': 'TV',
  'channel.email': 'Email',
  'channel.dashboard': 'Dashboard',
  'channel.print': 'Print',
  'codeSource.pms': 'PMS',
  'codeSource.reception': 'Reception',
  'codeSource.bulk': 'Bulk',
  'queueStatus.queued': 'Queued',
  'queueStatus.running': 'Running',
  'queueStatus.completed': 'Completed',
  'queueStatus.attention': 'Attention',
  'spaceKind.room': 'Room',
  'spaceKind.public-area': 'Public area',
  'spaceKind.event-hall': 'Event hall',
  'assignment.room': 'Room',
  'assignment.group': 'Group',
  'assignment.common': 'Common',
  'panMode.private': 'Private',
  'panMode.shared-group': 'Shared group',
  'panMode.public': 'Common',
  'role.tv-integration': 'TV integration',
  'role.platform-admin': 'Platform admin',
  'role.tenant-admin': 'Administrator',
  'role.reception': 'Concierge',
  'role.operations': 'Operations',
  'locationCategory.hotel': 'Hotel',
  'locationCategory.resort': 'Resort',
  'locationCategory.conference': 'Conference venue',
  'locationState.active': 'Active',
  'locationState.disabled': 'Disabled',
  'locationState.pending': 'Pending',
  'locationState.stable': 'Stable',
  'locationState.attention': 'Attention',
  'unitStatus.available': 'Available',
  'unitStatus.disabled': 'Disabled',
  'unitStatus.occupied': 'Occupied',
  'userStatus.active': 'Active',
  'userStatus.invited': 'Invited',
  'userStatus.disabled': 'Disabled',
  'reception.tab.hotel': 'Hotel',
  'reception.hotel.description': 'Rooms and common-area codes from PMS or Concierge',
  'reception.hotel.kicker': 'Hotel Wi-Fi codes',
  'reception.hotel.title': 'Manage room and common-area access codes',
  'admin.onboarding.kicker': 'Guided location onboarding',
  'admin.onboarding.title': 'Create and configure a new location',
  'admin.onboarding.description': 'Follow the vendor-to-Lumen handoff in the required order.',
  'admin.onboarding.step1': 'Controller', 'admin.onboarding.step2': 'Location', 'admin.onboarding.step3': 'Integrations', 'admin.onboarding.step4': 'Review', 'admin.onboarding.step5': 'Review',
  'admin.onboarding.locationKicker': 'Step 2 · Location details', 'admin.onboarding.locationTitle': 'Enter the new Location details',
  'admin.onboarding.controllerKicker': 'Step 1 · Vendor connection',
  'admin.onboarding.controllerTitle': 'Configure the location controller',
  'admin.onboarding.controllerHelp': 'Hardware, RF, AP groups and base SSIDs must already exist on the vendor platform.',
  'admin.onboarding.integrationsKicker': 'Step 3 · Optional integrations',
  'admin.onboarding.integrationsTitle': 'Configure PMS, TV and email delivery',
  'admin.onboarding.reviewKicker': 'Step 4 · Review',
  'admin.onboarding.reviewTitle': 'Confirm location configuration',
  'admin.onboarding.unitsNext': 'After saving, configure rooms, shared units and event halls with their VLAN and Network mappings.',
  'admin.onboarding.saveContinue': 'Save and configure units',
  'admin.unitsBulk.action': 'Bulk import',
  'admin.unitsBulk.kicker': 'Bulk unit import',
  'admin.unitsBulk.title': 'Import units from CSV',
  'admin.unitsBulk.description': 'Create rooms, shared areas and event halls in one operation.',
  'admin.unitsBulk.loadFile': 'Load CSV',
  'admin.unitsBulk.csv': 'Unit CSV',
  'admin.unitsBulk.hint': 'Columns: name, type, vlanId, serviceVlanId, networkId, panMode, capacity, assignment, status. Required: name, type, vlanId, networkId.',
  'admin.unitsBulk.importing': 'Importing...',
  'admin.unitsBulk.import': 'Import units',
  'admin.unitsBulk.completed': '{count} units imported.',
  'admin.unitsBulk.invalid': 'Invalid CSV: {error}',
  'admin.unitsBulk.noRows': 'No data rows found.',
  'admin.unitsBulk.missingColumns': 'Missing columns: {columns}.',
  'admin.unitsBulk.rowError': 'Invalid values on row {row}.'
};
